import { useSelector } from "react-redux";
import { useCallback, useEffect } from "react";
import TransTable from "../../common/TransTable";
import _ from "lodash";
import { Box, Button, IconButton, Switch, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { setLoading, setPotSetting, setPotSettingList, setSelectedLeagues, setUsers, setWaitinglistpot } from "../../../redux/action";
import { Link, useNavigate } from "react-router-dom";
import Axios from "axios";
import { base_url } from "../../backendurl/url";
import { useState } from "react";
import UpdatePopup from "../../Leagues/UpdatePopup";
import { Config } from "../../../utils/commonFuctions/Token";
import { RefreshToken } from "../../../utils/commonFuctions/RefreshToken";
import { Notification } from "../../common/Notification";
import { currencyformater } from "../../common/TransForm/currencyformater";


export default function Completepot() {
  const navigate = useNavigate();
  const {PotSettingList} = useSelector((state) => state);
  const [loading, setLoading] = useState(false)
  const [notification, setnotification] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const dispatch = useDispatch();
  const token = localStorage.getItem('token')
  const [popup, setPopup] = useState(false)
  const [leaguedetails, setLeagueDetails] = useState({})
   // Server-side pagination states
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [sortOrder, setSortOrder] = useState('');
    const [sortBy, setSortBy] = useState('');

  const userTableColumns = () => [
    {
      key: "id",
      label: "Round ID",
      align: "left",
      fontSize: '15px',

      valueRenderer: (data) => {
        return (
          <Link
            component={Typography}
            style={{ color: "#3C50E0", textDecoration: "underline" }}
            to={`completeround/view/${data.id}`}
            onClick={() => dispatch(setWaitinglistpot(data))}
          >
            {data["id"]}
          </Link>
        );
      },
    },
    { key: "category", label: "Round Category", align: "left", fontSize: "15px" },
    { key: "league", label: "League", align: "left", fontSize: "15px" },
     {
      key: "min_round_value_display",
      label: "Min Round Value",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        // return `${data['pot_currency']}  ${data['min_pot_value']}`
        return `${data['min_round_value_display']}`
      }
    },
     {
      key: "max_round_value_display",
      label: "Max Round value",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        return `${data['max_round_value_display']}`
      }
    },
    { key: "round_value_display", label: "Round Value", align: "left", fontSize: "15px" ,
    valueRenderer: (data) => {
      // return `${data['pot_currency']}  ${data['current_pot_value']}`
      return `${data['round_value_display']}`
      }
  },
    { key: "admin_fee", label: "Admin Fee %", align: "left", fontSize: "15px",
   
   },
    {
      key: "joined_picks",
      label: "No. of Picks Joined",
      align: "center",
      fontSize: "14px",
      px: "10px",
    },
    {
      key: "winners_count",
      label: "No. of Winners",
      align: "center",
      fontSize: '14px',
      px : "10px",
      valueRenderer: (data) => {
        return (
          <Link
            component={Typography}
            style={{ color: "#3C50E0", textDecoration: "underline" }}
            
            to={`completeround/winner/${data.id}`}
            onClick={() => dispatch(setWaitinglistpot(data))}
          >
            {data["winners_count"]}
          </Link>
        );
      },
    },
    { key: "prize_per_winner_display", label: "Prize Amount Per Winner", align: "left", fontSize: "15px",
    valueRenderer: (data) => {
      // return `${data['pot_currency']}  ${currencyformater(data['winning_amount'])}`
      return `${data['prize_per_winner_display']}`
      }
  },
  {
      key: "deadline_voting",
      label: "Deadline Voting Count",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        return `${data['deadline_voting']}`
      }
    },
     {
      key: "tokens_per_pick",
      label: "Tokens Per Pick",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        return `${data['tokens_per_pick']}`
      }
    },
    {
      key: "picks_per_player",
      label: "Picks Per Player",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        return `${data['picks_per_player']}`
      }
    },
  ];

  const getCompltePot = useCallback(async (page = 1, limit = 10, orderBy = '', order = '') => {
    setLoading(true)
    dispatch(setPotSettingList([]));
    try{
       // Build query parameters
      let queryParams = `page=${page}&limit=${limit}&status=Completed`;
      
      // Add sorting parameters if provided
      if (orderBy && order) {
        // queryParams += `&ordering=${order === 'desc' ? '-' : ''}${orderBy}`;
        queryParams += `&sort_by=${orderBy}&order=${order !== 'desc' ? 'desc' : 'asc'}`;

      }
       // console.log(`${base_url}/api/pot/rounds?${queryParams}`, "queryParamsCompleted")
      // if (_.isEmpty(PotSettingList) && !loading) {
       // const response = await Axios.get(`${base_url}/api/pot/pots?status=Completed`, Config);
      const response = await Axios.get(`${base_url}/api/pot/rounds?${queryParams}`, Config);
        if (response?.status == 200) {
          dispatch(setPotSettingList(response?.data?.results))
        setTotalCount(response?.data?.count); // Set total count from API response
          dispatch(setPotSetting({}))
          setLoading(false)
        }
      // }
     
    }
 catch(error){
  RefreshToken(error,setErrorMessage,setnotification)
 }
  }, [dispatch]);

    const handlePageChange = useCallback((page, rowsPerPage) => {
      setCurrentPage(page);
      setRowsPerPage(rowsPerPage);
      // API pages usually start from 1, but MUI pagination starts from 0
      getCompltePot(page + 1, rowsPerPage, sortBy, sortOrder);
    }, [sortBy, sortOrder, getCompltePot]);
  
    // Handle sorting change from TransTable
    const handleSortChange = useCallback((orderBy, order) => {
      setSortBy(orderBy);
      setSortOrder(order);
      // Reset to first page when sorting changes
      setCurrentPage(0);
      getCompltePot(1, rowsPerPage, orderBy, order);
    }, [rowsPerPage, getCompltePot]);

  const gotoAddUser = () => {
    navigate("add");
  };

    useEffect(() => {
    getCompltePot(1, 10); // Initial load
  }, [token]);


  // useEffect(() => {
  //   getCompltePot();
  // }, []);

  return (
    <>
      <Box  >
        <TransTable
          showSearch={false}
          checkbox={false}
          columns={userTableColumns()}
          rows={PotSettingList}
          addBtnAction={gotoAddUser}
          isLoading={loading}
           // Server-side pagination props
          serverSide={true}
          totalCount={totalCount}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onSortChange={handleSortChange}
        />
      <Notification message={errorMessage} setopen={setnotification} type={'error'} show={notification} />

      </Box>
    </>
  );
}
